<template>
	<app-page>
		<app-tabs app :tabs="tabs">
			<template v-slot:tab-item="{ tab }">
				<app-tab-item :tab="tab" value="redirections">
					<app-heading :title="`${website.name} Redirections`">
						<template v-slot:left>
							<app-button v-if="$ravello.can('website.post')"
								class="d-none d-sm-inline-flex"
								color="success"
								small
								outlined
								:to="{ name: 'website-redirection', params: { redirection: 'new' } }"
							>Add Redirection</app-button>
						</template>
						<template v-slot:right>
							<app-button
								v-if="$ravello.can('website.post')"
								color="secondary"
								icon="fa-file-download"
								small
								outlined
								@click="onExport"
							>
									Export
							</app-button>
							<input-file
								type="json"
								button
								small
								outlined
								label="Import"
								@load="onImport"
							/>
						</template>
					</app-heading>
					<app-row>
						<app-cell>
							<app-data-table
								:items="redirections"
								:headers="headers"
								:total="count"
								:refresh.sync="refresh"
								@update="fetchRedirections"
							>
								<template v-slot:actions="{ item }">
									<app-button
										v-if="$ravello.can('website.put')"
										color="secondary"
										:to="{ name: 'website-redirection', params: { redirection: item._id } }"
										icon="fa-pencil-alt"
										table
									>
										Edit
									</app-button>
									<app-button-confirm
										v-if="$ravello.can('website.delete')"
										color="error"
										icon="fa-trash"
										table
										label-confirm="Remove"
										:description="`Are you sure you want to remove `
											+ `redirection <b>${item.from}</b>?`"
										title="Remove Redirection"
										@click="onDelete(item._id)"
									>
										Remove
									</app-button-confirm>
								</template>
							</app-data-table>
						</app-cell>
					</app-row>
					<app-floating-button
						class="d-inline-flex d-sm-none"
						:to="{ name: 'website-redirection', params: { redirection: 'new' } }"
						color="success"
						icon="fa-plus"
					/>
				</app-tab-item>
			</template>
		</app-tabs>
	</app-page>
</template>

<script>
import { websiteContentTabs } from '@/datasources/tabs'

import { importCollection, exportCollection } from '@/utils/import'

export default {
	data() {
		return {
			website: {},
			redirections: [],
			count: -1,
			refresh: false,
			tabs: [],
			headers: [{
				text: 'From',
				value: 'from',
				sortable: true,
			}, {
				text: 'To',
				value: 'to',
				sortable: true,
			}, {
				text: 'Actions',
				value: 'actions',
				align: 'end',
				sortable: false,
			}],
		}
	},
	computed: {
		websiteId() {
			return this.$route.params.website
		},
	},
	async mounted() {
		this.website = await this.$ravello.graphql('website', this.websiteId)
			.fields(['name', 'template'])
			.query()
		this.tabs = websiteContentTabs(this.websiteId)
	},
	methods: {
		async fetchRedirections(pagination) {
			const request = this.$ravello.graphql('redirections')
				.parent(this.$ravello.graphql('website', this.websiteId))
				.fields(['_id', 'from', 'to'])
				.fromPagination(pagination)

			if (this.count === -1) {
				request.count('count')
			}
			try {
				this.redirections = await request.query()
				if (this.count === -1) {
					this.count = request.results.count
				}
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
		},

		async onDelete(id) {
			this.$store.dispatch('app/startLoading')
			try {
				await this.$ravello.request()
					.v(2)
					.to('websites')
					.to(this.websiteId)
					.to('redirections')
					.to(id)
					.delete()
				this.refresh = true
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
			this.$store.dispatch('app/stopLoading')
		},

		importRequest() {
			return this.$ravello.request()
				.v(2)
				.to('websites')
				.to(this.websiteId)
				.to('redirections')
		},

		async onExport() {
			this.$store.dispatch('app/startLoading')

			const request = this.importRequest().fields(['from', 'to'])
			await exportCollection(`${this.website.slug}_redirections.json`, request, {
				count: this.count,
			})

			this.$store.dispatch('app/stopLoading')
		},

		async onImport(importData) {
			this.$store.dispatch('app/startLoading')

			await importCollection(importData, this.importRequest(), 'from')
			this.refresh = true

			this.$store.dispatch('app/stopLoading')
		},
	},
}
</script>
